window.slate = window.slate || {};
window.theme = window.theme || {};

theme.normalizeBuilderLetters = function (value) {
  return String(value || '')
    .replace(/\u271D\uFE0F?/g, '\u2020')
    .replace(/\u2721\uFE0F?/g, '\u2020');
};

theme.normalizeBuilderLettersDisplay = function (root) {
  var scope = root || document;
  scope.querySelectorAll('.cart-letters-value__text, .minicart-property-item--letters .text-muted').forEach(function (el) {
    var text = el.textContent || '';
    if (text.indexOf('Letters:') === 0) {
      el.textContent = 'Letters: ' + theme.normalizeBuilderLetters(text.slice(8).trim());
      return;
    }
    if (text.indexOf('Charms:') === 0) {
      el.textContent = 'Charms: ' + theme.normalizeBuilderLetters(text.slice(7).trim());
      return;
    }
    el.textContent = theme.normalizeBuilderLetters(text);
  });
};

theme.syncBuilderLaunchButton = function (variant) {
  if (window.__productBuilder && typeof window.__productBuilder.updateLaunchButton === 'function') {
    if (variant && typeof window.__productBuilder.syncBaseVariantAvailability === 'function') {
      window.__productBuilder.syncBaseVariantAvailability(variant);
    }
    window.__productBuilder.updateLaunchButton();
    return true;
  }
  return false;
};

theme.isBuilderVariantPurchasable = function (variant) {
  if (!variant) return false;
  if (variant.available) return true;
  if (variant.inventory_policy === 'continue') return true;
  return false;
};

theme.isBuilderInstanceId = function (value) {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(String(value || '').trim())
    || String(value || '').indexOf('builder-') === 0;
};

theme.getCartItemProperty = function (item, name) {
  if (!item || !item.properties) return '';

  if (Array.isArray(item.properties)) {
    for (var i = 0; i < item.properties.length; i++) {
      if (item.properties[i] && item.properties[i].name === name) {
        return item.properties[i].value == null ? '' : String(item.properties[i].value);
      }
    }
    return '';
  }

  return item.properties[name] == null ? '' : String(item.properties[name]);
};

theme.getCartItemPropertiesObject = function (item) {
  var props = {};
  if (!item || !item.properties) return props;

  if (Array.isArray(item.properties)) {
    item.properties.forEach(function (entry) {
      if (entry && entry.name) {
        props[entry.name] = entry.value == null ? '' : String(entry.value);
      }
    });
    return props;
  }

  Object.keys(item.properties).forEach(function (key) {
    props[key] = item.properties[key] == null ? '' : String(item.properties[key]);
  });
  return props;
};

theme.findCartLineNumber = function (cart, itemKey) {
  if (!cart || !cart.items || !itemKey) return -1;

  for (var i = 0; i < cart.items.length; i++) {
    if (cart.items[i].key === itemKey) {
      return i + 1;
    }
  }

  return -1;
};

theme.formatBuilderSlotDesign = function (entries) {
  return (entries || []).map(function (entry) {
    var token = theme.normalizeBuilderLetters(entry.token || '');
    var placement = entry.placement || '';

    if (placement) {
      return token + ' (' + placement + ')';
    }

    return token;
  }).join(' · ');
};

theme.computeBuilderDesignFromCharms = function (charmItems) {
  var sorted = (charmItems || []).slice().sort(function (a, b) {
    var posA = parseInt(theme.getCartItemProperty(a, '_position'), 10);
    var posB = parseInt(theme.getCartItemProperty(b, '_position'), 10);
    if (isNaN(posA)) posA = 0;
    if (isNaN(posB)) posB = 0;
    return posA - posB;
  });

  var hasSlotMeta = sorted.some(function (item) {
    return theme.getCartItemProperty(item, 'Slot');
  });

  if (hasSlotMeta) {
    return theme.formatBuilderSlotDesign(sorted.map(function (item) {
      var letter = theme.getCartItemProperty(item, '_Letter');
      var charm = theme.getCartItemProperty(item, '_Charm');
      var token = letter || charm || '';

      return {
        token: token,
        placement: theme.getCartItemProperty(item, 'Slot')
      };
    }));
  }

  return sorted.map(function (item) {
    var letter = theme.getCartItemProperty(item, '_Letter');
    if (letter) return theme.normalizeBuilderLetters(letter);

    var charm = theme.getCartItemProperty(item, '_Charm');
    if (charm) return theme.normalizeBuilderLetters(charm);

    return '';
  }).join('');
};

theme.syncBuilderCartGroups = function (cart, done) {
  if (typeof jQuery === 'undefined') {
    if (done) done(cart);
    return;
  }

  if (theme._syncingBuilderCart) {
    if (done) done(cart);
    return;
  }

  var finish = function (nextCart) {
    theme._syncingBuilderCart = false;
    if (typeof theme.normalizeBuilderLettersDisplay === 'function') {
      theme.normalizeBuilderLettersDisplay(document.getElementById('minicart'));
    }
    if (done) done(nextCart || cart);
  };

  var runSync = function (currentCart) {
    if (!currentCart || !currentCart.items || !currentCart.items.length) {
      finish(currentCart);
      return;
    }

    var groups = {};
    currentCart.items.forEach(function (item) {
      if ((item.quantity || 0) <= 0) return;

      var builderId = theme.getCartItemProperty(item, '_builder_id');
      if (!builderId) return;

      if (!groups[builderId]) {
        groups[builderId] = { base: null, charms: [] };
      }

      var role = theme.getCartItemProperty(item, '_builder_role');
      if (role === 'base') {
        groups[builderId].base = item;
      } else if (role === 'charm') {
        groups[builderId].charms.push(item);
      }
    });

    var updates = [];
    Object.keys(groups).forEach(function (builderId) {
      var group = groups[builderId];
      if (!group.base) return;

      var design = theme.computeBuilderDesignFromCharms(group.charms);
      var currentDesign = theme.getCartItemProperty(group.base, 'Charms')
        || theme.getCartItemProperty(group.base, 'Letters');
      var designNeedSync = currentDesign !== design
        || theme.isBuilderInstanceId(currentDesign)
        || theme.getCartItemProperty(group.base, 'Letters');

      group.charms.forEach(function (charmItem) {
        if (theme.getCartItemProperty(charmItem, '_Design') !== design) {
          updates.push({
            item: charmItem,
            properties: jQuery.extend({}, theme.getCartItemPropertiesObject(charmItem), { _Design: design })
          });
        }
      });

      if (designNeedSync) {
        var baseProps = jQuery.extend({}, theme.getCartItemPropertiesObject(group.base), {
          Charms: design
        });
        delete baseProps.Letters;
        updates.unshift({
          item: group.base,
          properties: baseProps
        });
      }
    });

    if (!updates.length) {
      finish(currentCart);
      return;
    }

    theme._syncingBuilderCart = true;

    var applyNextUpdate = function () {
      if (!updates.length) {
        if (typeof CartJS !== 'undefined' && CartJS.getCart) {
          CartJS.getCart({
            success: function (freshCart) {
              finish(freshCart);
            },
            error: function () {
              finish(currentCart);
            }
          });
          return;
        }

        jQuery.getJSON('/cart.js', function (freshCart) {
          if (typeof CartJS !== 'undefined' && CartJS.cart && typeof CartJS.cart.update === 'function') {
            CartJS.cart.update(freshCart);
          }
          finish(freshCart);
        });
        return;
      }

      var update = updates.shift();
      var line = theme.findCartLineNumber(currentCart, update.item.key);
      if (line === -1) {
        applyNextUpdate();
        return;
      }

      var payload = {
        line: line,
        quantity: update.item.quantity
      };

      Object.keys(update.properties).forEach(function (key) {
        payload['properties[' + key + ']'] = update.properties[key];
      });

      jQuery.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: payload,
        dataType: 'json',
        success: function (nextCart) {
          currentCart = nextCart;
          applyNextUpdate();
        },
        error: function () {
          applyNextUpdate();
        }
      });
    };

    applyNextUpdate();
  };

  if (cart && cart.items) {
    runSync(cart);
    return;
  }

  jQuery.getJSON('/cart.js', runSync);
};

(function () {
  var syncTimeout = null;

  function scheduleBuilderCartSync(cart) {
    if (typeof jQuery === 'undefined') return;
    if (syncTimeout) clearTimeout(syncTimeout);
    syncTimeout = setTimeout(function () {
      theme.syncBuilderCartGroups(cart);
    }, 350);
  }

  function bindBuilderCartSync() {
    jQuery(document).on('cart.requestComplete.themeBuilderSync', function (event, cart) {
      scheduleBuilderCartSync(cart);
    });
  }

  if (typeof jQuery !== 'undefined') {
    bindBuilderCartSync();
  } else {
    document.addEventListener('DOMContentLoaded', bindBuilderCartSync);
  }
})();

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if(src == undefined) {
      src = "";
    }
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;
console.log("onselectchange");
      let html = "";
      if(variant.title.indexOf('No Chain') > -1) {
        html = 'Chain <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width="12" style="margin-left:5px"><g fill="none" fill-rule="evenodd" stroke="#000" stroke-width="1" stroke-linecap="square"><path d="M6 1v10M11 6H1"/></g></svg>';
        $("#pair-with-chain").removeClass("btn-remove-chain").addClass("btn-add-chain");
      } else {
        html = variant.title + '&nbsp;-&nbsp;<small style="font-weight: 600; text-decoration: none;">Remove</small>';
        $("#pair-with-chain").removeClass("btn-add-chain").addClass("btn-remove-chain");
      }

      
      $("span.chain-name").html(html);

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });

      $(".chain-variant-image").removeClass("hidden").addClass("hidden");
      $(".mobile-chain-variant-image").removeClass("hidden").addClass("hidden");
console.log("variant", variant);
      if(variant.title.indexOf('No Chain') > -1) {
        // $(".chain-variant-image[data-variant-id='" + variant.id + "']").removeClass("hidden");
        // $(".mobile-chain-variant-image[data-variant-id='" + variant.id + "']").removeClass("hidden");
        $(".chain-variant-image.main-chain-image").removeClass("hidden");
        $(".mobile-chain-variant-image.mobile-main-chain-image").removeClass("hidden");
      } else {
        $(".chain-variant-image[data-variant-id='" + variant.id + "']").removeClass("hidden");
        $(".mobile-chain-variant-image[data-variant-id='" + variant.id + "']").removeClass("hidden");
      }
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */


theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;
      var isBuilderProduct = this.$container.is('[data-is-builder-product]')
        || this.$container.closest('[data-is-builder-product]').length > 0;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (isBuilderProduct) {
        if (theme.syncBuilderLaunchButton(variant)) {
          return;
        }

        var launchBtn = document.querySelector('[data-builder-launch]');
        var canPurchase = theme.isBuilderVariantPurchasable(variant);

        if (canPurchase) {
          if (launchBtn) {
            launchBtn.style.display = '';
            launchBtn.disabled = false;
            launchBtn.removeAttribute('disabled');
          }
          $(".sold-out-btn").hide();
        } else {
          if (launchBtn) {
            launchBtn.style.display = 'none';
            launchBtn.disabled = true;
          }
          $(".sold-out-btn").show();
        }
        return;
      }

      if (variant.available == true || isMadeToOrder == true) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
        $('#out-of-stock-message').fadeOut(200);
        $(".in-stock-btn").show();
        $(".sold-out-btn").hide();
      } else if (isMadeToOrder == false) {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
        $(".in-stock-btn").hide();
        $(".sold-out-btn").show();
        $('#out-of-stock-message').fadeIn(200);
      }

      // var madeToOrderValue = $("select option[data-madetoorder='true']").val();
      var madeToOrderValue = $("select option[data-madetoorder='true']").map(function (idx, ele) {
          return $(ele).val();
      }).get();
      if (isMadeToOrder == true && $.inArray(variant.title, madeToOrderValue) !== -1) {
        $(".made-to-order-alert").show();
      } else {
        $(".made-to-order-alert").hide();
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

$(document).ready(function() {

  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }
  
  if(typeof Shopify.queryParams.sort_by != 'undefined') {
    var sortByValue = Shopify.queryParams.sort_by;
  } else {
    var sortByValue = jQuery('#sortForm').attr('data-default');
    var sortByValueMobile = jQuery('#sortFormMobile').attr('data-default');
  }


  jQuery('#sort-by')
    .val(sortByValue)
    .bind('change', function() {
      Shopify.queryParams.sort_by = jQuery(this).val();
      // location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
  });
  
  jQuery('#sort-by-mobile')
    .val(sortByValueMobile)
    .bind('change', function() {
      Shopify.queryParams.sort_by = jQuery(this).val();
      // location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
  });


});

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();



function createCookie(name,value,days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name,"",-1);
}


var touchmoved;
$('.touchevents a.touchlink').on('click tap', function(e){
    e.preventDefault();
}).on('touchend', function(e){
    if(touchmoved != true){
        // button click action
        window.location.href = $(this).attr('href');
        return true;
        //e.preventDefault();
    } else {
        e.preventDefault();
    }
}).on('touchmove', function(e){
    touchmoved = true;
}).on('touchstart', function(){
    touchmoved = false;
});


var touchmoved;
$('.touchevents .collection_product a').on('click tap', function(e){
    e.preventDefault();
}).on('touchend', function(e){
    if(touchmoved != true){
        // button click action
        window.location.href = $(this).attr('href');
        return true;
        //e.preventDefault();
    } else {
        e.preventDefault();
    }
}).on('touchmove', function(e){
    touchmoved = true;
}).on('touchstart', function(){
    touchmoved = false;
});


if($('body').hasClass('template-collection')) {

    var productView = readCookie('productView');
    if(productView) {
        $('#bc-sf-filter-products').addClass(productView);
        $('#grid_view #' + productView).addClass('active');
    } else {
        $('#grid_view #col2').addClass('active');
    }

    $('.collection-grid').addClass(productView);
  
  	$('#productCollectionFilterToggle select').click(function(){
      $(this).toggleClass('active');
      $('#filter_container').toggle();
      // $('#productCollectionFilterWrapper').slideToggle(0,'linear');
  });

    $(document).on('click', "#productCollectionFilterToggle", function(){
            
      $(this).toggleClass('active');
      $('#filter_container').toggle();
      // $('#productCollectionFilterWrapper').slideToggle(0,'linear');

    });
    

    

};

$(document).ready(function() {


    //var wrap = $(window);
    
    // leading edge, instead of the trailing.
    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    var setSticky = debounce(function() {
        if ($(window).scrollTop() > 0) {
            $('body').addClass("sticky-header");
          } else {
            $('body').removeClass("sticky-header");
          }
    }, 0);

    window.addEventListener('scroll', setSticky);



    // minicart

    function scrollMinicartToTop(behavior) {
        var el = document.getElementById('minicartScrollWrapper');
        if (!el) return;

        try {
            el.scrollTo({ top: 0, behavior: behavior || 'auto' });
        } catch (error) {
            el.scrollTop = 0;
        }
    }

    window.scrollMinicartToTop = scrollMinicartToTop;

    theme.minicartAutoOpenToken = 0;
    theme.minicartAutoOpenTimer = null;

    theme.cancelMinicartAutoOpen = function() {
        theme.minicartAutoOpenToken += 1;
        if (theme.minicartAutoOpenTimer) {
            clearTimeout(theme.minicartAutoOpenTimer);
            theme.minicartAutoOpenTimer = null;
        }
        $(document).off('cart.requestComplete.themeMinicartAutoOpen');
    };

    theme.openMinicart = function() {
        $('html').addClass('minicart-open');
    };

    theme.openMinicartOnCartComplete = function(options) {
        options = options || {};
        var delay = options.delay || 0;
        var beforeOpen = options.beforeOpen;
        var token = theme.minicartAutoOpenToken + 1;
        theme.minicartAutoOpenToken = token;

        $(document).one('cart.requestComplete.themeMinicartAutoOpen', function() {
            if (token !== theme.minicartAutoOpenToken) return;

            var open = function() {
                if (token !== theme.minicartAutoOpenToken) return;
                if (typeof beforeOpen === 'function') beforeOpen();
                theme.openMinicart();
            };

            if (delay) {
                theme.minicartAutoOpenTimer = setTimeout(open, delay);
            } else {
                open();
            }
        });
    };

    theme.closeMinicart = function() {
        theme.cancelMinicartAutoOpen();
        $('html').removeClass('minicart-open');
    };

    var minicartWasOpen = document.documentElement.classList.contains('minicart-open');
    var minicartOpenObserver = new MutationObserver(function() {
        var isOpen = document.documentElement.classList.contains('minicart-open');
        if (isOpen && !minicartWasOpen) {
            scrollMinicartToTop('auto');
        }
        minicartWasOpen = isOpen;
    });

    minicartOpenObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class']
    });

    $('a.basket_link').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        if(!$('body').hasClass('template-cart')) {
            $('html').toggleClass('minicart-open');
        }
        
    });

    $('#minicart_close').on('click', function(e){
        e.preventDefault();
        theme.closeMinicart();
    });

    $('#pageWrapper').on('click', function(e){
        if($('html').hasClass('minicart-open')){
            e.preventDefault();
            theme.closeMinicart();
        }
    });






  // SEARCH TOGGLE
  function isMobileSearchMode() {
      return window.matchMedia('(max-width: 1230px)').matches || $('.burger:visible').length > 0;
  }

  function syncSearchContainerForViewport() {
      var $container = $('#searchFormContainer');

      if (isMobileSearchMode()) {
          $container.css('display', '');
          return;
      }

      if ($('body').hasClass('search-open')) {
          $container.css('display', 'flex');
      } else {
          $container.css('display', 'none');
      }
  }

  function closeSearchOverlay() {
      if (isMobileSearchMode()) {
          var $input = $('#searchForm input');
          $input.val('');
          $input.removeAttr('data-old-term');
          $input.trigger('change');
      }

      $('body').removeClass('search-open');
      $('#searchForm input').blur();
      syncSearchContainerForViewport();
  }

  function openSearchOverlay() {
      $('body').addClass('search-open');

      if (!isMobileSearchMode()) {
          $('#searchFormContainer').css("display", "flex");
          $('#searchFormContainer')[0].offsetHeight;
      } else {
          syncSearchContainerForViewport();
      }

      $('#searchForm input').focus();
  }

  var searchResizeTimer;
  $(window).on('resize', function(){
      clearTimeout(searchResizeTimer);
      searchResizeTimer = setTimeout(syncSearchContainerForViewport, 100);
  });

  $('.search_toggle').on('click', function(){
      if($('body').hasClass('search-open')) {
          closeSearchOverlay();
      } else {
          openSearchOverlay();
      }
  });

  $('.search-overlay').on('click', function(){
      closeSearchOverlay();
  });

  function openMobileSearchFromInput() {
      if (isMobileSearchMode() && !$('body').hasClass('search-open')) {
          openSearchOverlay();
      }
  }

  $('#searchForm input').on('focus click', function(){
      openMobileSearchFromInput();
  });

  $('#searchForm').on('click', function(e){
      if ($(e.target).closest('.icon-close').length) {
          return;
      }
      openMobileSearchFromInput();
  });

    $('.site-nav__submenuWrapper_inner > ul > li:not(.menu_image)').on('mouseenter', function(){
        var item = parseInt($(this).attr('data-item')) - 1;
        $('.menu-image-item').removeClass('active');
        $('.menu-image-item:eq(' + item + ')').addClass('active');
    });


    var closeMenu;
    var closeMenuAnim;

    $("li.site-nav--has-submenu a, .site-nav__submenu").hover(function(){
        if(!$('#burger').is(":visible")) {
            clearTimeout(closeMenu);
            clearTimeout(closeMenuAnim);
            var sectionToOpen = $(this).attr('data-dropdown');
           //console.log(sectionToOpen);
            $('body').addClass('menu-open');
          	$('.site-nav__submenu').removeClass('active');
            $('.site-nav__submenu#' + sectionToOpen).addClass('active');
          	$('.site-nav li a span').removeClass('hover');
            $('.site-nav li a#link_' + sectionToOpen + ' span').addClass('hover');

            $('#searchFormContainer').fadeOut(0);
            $('body').removeClass('search-open');
        }
    },function(){
        if(!$('#burger').is(":visible")) {
            closeMenu = setTimeout(function(){
                $('body').addClass('menu-closing');
                $('body').removeClass('menu-open');
                $('.site-nav__submenu').removeClass('active');
                $('.site-nav li a span').removeClass('hover');
                $('.menu-image-item').removeClass('active');
                $('.menu-image-item:eq(0)').addClass('active');

                closeMenuAnim = setTimeout(function(){
                    $('body').removeClass('menu-closing');
                },100);

            },100);
        }
    });
  
  
  	$("li.site-nav--has-submenu a").hover(function () {
      $("li.site-nav--has-submenu a").toggleClass('active');
    });




    


    if($('body').hasClass('template-collection')) {

        $('#productCollectionFilterToggle').on('click', function(){
            
            $(this).toggleClass('active');

        });

        $('#grid_view div').on('click', function(){
            var view = $(this).attr('data-view');
            //console.log(view);

            createCookie('productView', view, 365);

            $('.collection-grid').removeClass('col1 col2');
            $('.collection-grid').addClass(view);

            $('#grid_view div').removeClass('active');
            $(this).addClass('active');

        });




    }

    if($('.collection_product').length) {

        //bind the touchstart event to the link element
        $('.collection_product').on('touchstart', function(e){
             $(this).find('a.product_image').addClass('hover');
            //alert('alert');
        }).on('touchend', function(){
            $('a.product_image').removeClass('hover');
            //alert('alert');
        });

  

    }

    if($('body').hasClass('template-product') || $('body').hasClass('template-article')) {


        $('input[name=single_pair]').on('change', function(){
            var newQuantity = $('input[name=single_pair]:checked').val();
            $("#quantity_selector #value").html(newQuantity);
            $("#Quantity").val(newQuantity);

        });

        // QUANTITY

        $("#quantity_selector #more").on('click', function(e){
          var value = $(this).parent('#quantity_selector').find('#value');
          var currentQuantity = parseInt(value.html());
          var newQuantity = currentQuantity+1;
          value.html(newQuantity);
          $(this).parents('form').find("#Quantity").val(newQuantity);
        }); 

        $("#quantity_selector #less").on('click', function(e){
          var value = $(this).parent('#quantity_selector').find('#value');
          var currentQuantity = parseInt(value.html());
          var newQuantity = currentQuantity-1;
          if (newQuantity>=1){
            value.html(newQuantity);
            $(this).parents('form').find("#Quantity").val(newQuantity);
          }
        }); 


        // SIZE GUIDE

        $('#productSizeGuideLink a').on('click', function(e){
            e.preventDefault();
            $('#productSizeGuideWrapper').show();
            $('#overlayBG').fadeIn(300);
            $('html, body').animate({ scrollTop: 0 }, 300);
        }); 

        $('#productSizeGuideClose').on('click', function(e){
            $('#productSizeGuideWrapper').hide();
            $('#overlayBG').fadeOut(300);
        }); 

        
        // ENGRAVING



        $('#productEngravingSubmit').on('click', function(e){
            var productJson = JSON.parse($("[data-product-json]").html());
            var productHandle = productJson.handle;

            if (productHandle == 'gold-band-ring' || productHandle == 'silver-band-ring') {
              var engravingString = '';
              if ($("#insideEngravingCopy").val().length > 0) {
                engravingString += $("#insideEngravingCopy").val();
              }

              if ($("#insideEngravingCopy").val().length > 0 && $("#outsideEngravingCopy").val().length > 0) {
                engravingString += ", ";
              }

              if($("#outsideEngravingCopy").val().length > 0) {
                engravingString += $("#outsideEngravingCopy").val();
              }

              $('.product-rhs').show();
              $('.product-rhs.rhs-overlay').hide();
              $('.button.engraving-overlay-trigger .label').show();
              $('.button.engraving-overlay-trigger .name').text(engravingString);

            } else {
  var copy     = $("#engravingCopy").val().trim();
  var option   = $("#engravingOption").val(); // "Letter & Date" or "Letters"
  var dateVal = ($("#engravingDate").val() || '').trim();


  if (!copy) {
    $('#engravingErrMsg').fadeIn(300);
    return;
  } else {
    $('#engravingErrMsg').hide();
  }

  var display = copy;

  if (option === 'Letter & Date') {
    var dateDigits = dateVal.replace(/\D/g, '');
    if (dateDigits.length !== 6) {
      $('#engravingDateErr').fadeIn(300);
      return;
    }
    $('#engravingDateErr').hide();

    // normalise to "DD MM YY"
    dateVal = dateDigits.replace(/(\d{2})(\d{2})(\d{2})/, '$1 $2 $3');

    // 🔑 add the date to the display string
    display = copy + ' • ' + dateVal;
  } else {
    $('#engravingDateErr').hide();
  }

  $('.product-rhs').show();
  $('.product-rhs.rhs-overlay').hide();
  $('.button.engraving-overlay-trigger .label').show();
  $('.button.engraving-overlay-trigger .name').text(display);
}



        });


        if( typeof(productOptions ) != "undefined" ){
            for(i=0;i<productOptions.length;i++) {
              $('.single-option-selector:eq('+ i +')')
              .filter(function() {
                return $(this).find('option').length > 1
              })
              .prepend('<option value="">Pick a ' + productOptions[i][i] + '</option>')
              .val('')
              .trigger('change');
            }
          }
          


        $('#productEngravingWrapper .engraving_font_select').on('click', function(){

            $('#productEngravingWrapper .engraving_font_select').removeClass('selected');
            $(this).addClass('selected');

            var characters = $(this).attr('data-chars');
            var font = $(this).attr('data-font');
            var item = $( "#productEngravingWrapper .engraving_font_select" ).index($(this));

            $("#engravingCopy").val('');

            $('#maxcharErr').html(characters);
            $('#maxchar').html(characters);
            $("#engravingCopy").attr('maxlength', characters);
                

            $('#engravingFont').val(font);
            //$('#engravingFont option').prop('selected', false);
            //$('#engravingFont option:eq(' + item + ')').prop('selected', true);

        });

        $('input[name="properties[Position]"]').change(function() {
          var value = $(this).val();

          if (value == "Internal") {
            $("#outside_engraving_text").hide();
            $("#inside_engraving_text").show();
          } else if (value == "External") {
            $("#outside_engraving_text").show();
            $("#inside_engraving_text").hide();
          } else if (value == "Both") {
            $("#outside_engraving_text").show();
            $("#inside_engraving_text").show();
          } else {
            alert("Something went wrong!");
          }
        });

        $("#engraving-confirm-button").on("click", function() {
          MicroModal.close("engraving-confirm-modal");
          MicroModal.close("name-confirm-modal");
          return addToCartOT(
            $("[name='id[]']").map(function(){
              if($(this).val() != -1) {
                return $(this).val();
              }
            }).get(),
            $('#Quantity').val(),
            []
          );
        });

        $("#name-cancel-button").on("click", function() {
          MicroModal.close("name-confirm-modal");
        });

        $("#date-cancel-button").on("click", function() {
          MicroModal.close("date-confirm-modal");
        });
        
        $("#engraving-cancel-button").on("click", function() {
          MicroModal.close("engraving-confirm-modal");
          // MicroModal.show("engraving-modal");
        });

        $('form#productForm').on('submit', function(){

            var shippinginfo = $('#shippinginfo').val();


            //console.log( $("input[name=properties]").val());
            if($('#Engraved').length) {

                var product_engraved_id = $('#engravingProductId').val();
                var product_engraved = $('#engravingProductTitle').val();
                var engraved_copy = $('#engravingCopy').val();
                var engraved_font = $('#engravingFont').val();
                var engraved_type_id = $('#engravingTypeId').val();
                var productJson = JSON.parse($("[data-product-json]").html());
                var productHandle = productJson.handle;
                var additionalCharacterJson = JSON.parse($("[data-additional-character-json]").html());
                var additionalCharacterVariant = additionalCharacterJson.variants[0].id;
                var additionalCharacterPrice = additionalCharacterJson.variants[0].price;
                var engraving_length = 0;
                var engraved_option = $('#engravingOption').val() || '';
                var engraved_date   = ($('#engravingDate').val() || '').trim();

                if (productHandle == 'gold-band-ring' || productHandle == 'silver-band-ring') {
                  engraving_length = $("form #insideEngravingCopy").val().replace(/\s/g, "").length + $("form #outsideEngravingCopy").val().replace(/\s/g, "").length;
                  engraved_copy = '';
                  if ($("form #insideEngravingCopy").val().length > 0) {
                    engraved_copy += $("form #insideEngravingCopy").val();
                  }

                  if ($("form #insideEngravingCopy").val().length > 0 && $("form #outsideEngravingCopy").val().length > 0) {
                    engraved_copy += ", ";
                  }

                  if($("form #outsideEngravingCopy").val().length > 0) {
                    engraved_copy += $("form #outsideEngravingCopy").val();
                  }

                  if (engraving_length > max_characters) {
                    CartJS.addItem(additionalCharacterVariant, engraving_length - max_characters, {"Product": product_engraved, "Engraving": engraved_copy}, {
                      // Define a success callback to display a success message.
                      "success": function(data, textStatus, jqXHR) {
                          fetch('/cart.js', {
                            method: "GET",
                          }).then(response => {
                            console.log(response);
                          });
                        
                        return;
                      },
  
                      // Define an error callback to display an error message.
                      "error": function(jqXHR, textStatus, errorThrown) {
                          console.log(variantId);
                          console.log(errorThrown);
                      }
                    });
                  }
                }
                if($('input[name="properties[Position]"]').length) {
                    var engraved_position = $('input[name="properties[Position]"]:checked').val();
                } else {
                    var engraved_position = "";
                }

                if (productHandle == 'personalised-name-bracelet' || productHandle == 'name-bracelet-silver' || productHandle == 'personalised-name-bracelet-gold-vermeil' || productHandle == 'mixed-metal-name-bracelet' || productHandle == 'name-pendant-vermeil' || productHandle == 'solid-gold-name-pendant' || productHandle == 'silver-name-pendant') {
                  if(engraved_copy == "") {
                    MicroModal.show("name-confirm-modal");
                    $('.product-rhs').hide();
                    $('.product-rhs.name-bracelet-pendant-overlay').show();
                    return false;
                  }

                  $(".name-bracelet-pendant-overlay-trigger-close").on("click", function() {
                    MicroModal.close("name-confirm-modal");
                  });
                }

                if (productHandle == 'date-pendant-vermeil' || productHandle == 'solid-gold-date-pendant' || productHandle == 'silver-date-pendant') {
                  if(engraved_copy == "") {
                    MicroModal.show("date-confirm-modal");
                    $('.product-rhs').hide();
                    $('.product-rhs.date-pendant-overlay').show();
                    return false;
                  }

                  $(".date-pendant-overlay-trigger-close").on("click", function() {
                    MicroModal.close("date-confirm-modal");
                  });
                }

                if (engraved_copy == "") {
                  var skipModalIds = ['15189860122998','15188974305654','1355312627755','15405177110902','15414293266806'];
                  var currentProductId = String(productJson.id || '');

                  // Only show the confirm modal if NOT on one of the skip products
                  if (!skipModalIds.includes(currentProductId)) {
                    MicroModal.show("engraving-confirm-modal");
                    return false; // block submit until confirmed
                  }
                  // else: let the submit proceed without showing the modal
                }


                $('#productEngraving').appendTo($('#formNoIncludeEngraving'));  
                $('#engravingCopy').val('');

                var variantId = engraved_type_id;

                properties = {
                  '_shippinginfo': shippinginfo,
                  'Letters': engraved_copy,
                  'product_engraved_id': product_engraved_id
                };

                // --- Engraving Fee for specific products ---
(function addEngravingFeeIfNeeded() {
  var eligibleIds = ['15189860122998','15188974305654','1355312627755'];

  // Only if there is engraving text AND product is eligible
  if (!engraved_copy || eligibleIds.indexOf(String(productJson.id)) === -1) return;

  var raw = $('[data-engraving-fee-json]').html();
  if (!raw) { console.warn('[EngravingFee] No fee JSON on page'); return; }

  var feeJson;
  try { feeJson = JSON.parse(raw); } catch(e) { console.warn('[EngravingFee] JSON parse error', e); return; }

  var feeVariantId = feeJson && feeJson.variants && feeJson.variants[0] && feeJson.variants[0].id;
  if (!feeVariantId) { console.warn('[EngravingFee] No fee variant id'); return; }

  var feeQty = parseInt($('#Quantity').val(), 10) || 1;

  // Link the fee line to this engraving (helps with pairing/removal)
  var feeProps = {
    'Product': product_engraved,
    'Letters': engraved_copy
  };
  if (engraved_option) feeProps['Engraving Option'] = engraved_option;
  if (engraved_date)   feeProps['Date'] = engraved_date;

  CartJS.addItem(feeVariantId, feeQty, feeProps, {
    success: function(){ console.log('[EngravingFee] Added'); },
    error:   function(jqXHR, textStatus, errorThrown){
      console.warn('[EngravingFee] Add error', errorThrown);
    }
  });
})();

                // --- Embroidery Fee for specific products ---
(function addEmbroideryFeeIfNeeded() {
  var embroideryProductIds = ['15405177110902', '15414293266806'];

  // Only if there is embroidery text AND product is an embroidery product
  if (!engraved_copy || embroideryProductIds.indexOf(String(productJson.id)) === -1) return;

  var raw = $('[data-embroidery-fee-json]').html();
  if (!raw) { console.warn('[EmbroideryFee] No fee JSON on page'); return; }

  var feeJson;
  try { feeJson = JSON.parse(raw); } catch(e) { console.warn('[EmbroideryFee] JSON parse error', e); return; }

  var feeVariantId = feeJson && feeJson.variants && feeJson.variants[0] && feeJson.variants[0].id;
  if (!feeVariantId) { console.warn('[EmbroideryFee] No fee variant id'); return; }

  var feeQty = parseInt($('#Quantity').val(), 10) || 1;

  // Link the fee line to this embroidery (helps with pairing/removal)
  var feeProps = {
    'Product': product_engraved,
    'Letters': engraved_copy
  };
  if (engraved_option) feeProps['Engraving Option'] = engraved_option;
  if (engraved_date)   feeProps['Date'] = engraved_date;

  CartJS.addItem(feeVariantId, feeQty, feeProps, {
    success: function(){ console.log('[EmbroideryFee] Added'); },
    error:   function(jqXHR, textStatus, errorThrown){
      console.warn('[EmbroideryFee] Add error', errorThrown);
    }
  });
})();



                                // only include when present
if (engraved_copy)     properties['Letters'] = engraved_copy;
if (engraved_font)     properties['Font']    = engraved_font;
if (engraved_position) properties['Position']= engraved_position;
if (engraved_option)   properties['Engraving Option'] = engraved_option;
if (engraved_option === 'Letter & Date' && engraved_date) {
  // normalise to "DD MM YY" if typed as digits
  var d = engraved_date.replace(/\D/g, '');
  if (d.length === 6) engraved_date = d.replace(/(\d{2})(\d{2})(\d{2})/, '$1 $2 $3');
  properties['Date'] = engraved_date;
}





                if ((productHandle == 'gold-band-ring' || productHandle == 'silver-band-ring') && engraving_length > max_characters) {
                  var additionalCount = engraving_length - max_characters;
                  var div = document.createElement('div');
                  div.innerHTML = slate.Currency.formatMoney(additionalCharacterPrice * additionalCount, theme.moneyFormat).trim();
                  var formattedMoney = div.firstChild.innerHTML;
                  properties["Additional characters"] = additionalCount + "(+" + formattedMoney + ")";
                }
                

                
                var items = [
                  {
                    "id": variantId,
                    "quantity": 1,
                    "properties": properties
                  },
                  {
                    "id": $("[name='id[]']").map(function(){
                      console.log($(this).val());
                      if($(this).val() != -1) {
                        return $(this).val();
                      }
                    }).get(),
                    "quantity": 1,
                    "properties": properties
                  }
                ];
              
                var ajaxData = {
                  "items": items
                }
                

                
              if (typeof items[1].id == "object" && items[1].id.length > 1) {
                CartJS.addItem(items[1].id[0], 1, items[1].properties, {

                    // Define a success callback to display a success message.
                    "success": function(data, textStatus, jqXHR) {
                        fetch('/cart.js', {
                          method: "GET",
                        }).then(response => {
                          console.log(response);
                        });
                      
                      return;
                    },

                    // Define an error callback to display an error message.
                    "error": function(jqXHR, textStatus, errorThrown) {
                        console.log(variantId);
                        console.log(errorThrown);
                    }

                });

                CartJS.addItem(items[1].id[1], 1, [], {

                    // Define a success callback to display a success message.
                    "success": function(data, textStatus, jqXHR) {
                        theme.openMinicartOnCartComplete();
                      return;
                    },

                    // Define an error callback to display an error message.
                    "error": function(jqXHR, textStatus, errorThrown) {
                        console.log(variantId);
                        console.log(errorThrown);
                    }

                });
              } else {
                CartJS.addItem(items[1].id, 1, items[1].properties, {

                    // Define a success callback to display a success message.
                    "success": function(data, textStatus, jqXHR) {
                        if(productHandle == 'gold-band-ring' || productHandle == 'silver-band-ring') {
                          theme.openMinicartOnCartComplete({ delay: 3000, beforeOpen: checkCharacters });
                        } else {
                          theme.openMinicartOnCartComplete();
                        }
                      return;
                    },

                    // Define an error callback to display an error message.
                    "error": function(jqXHR, textStatus, errorThrown) {
                        console.log(variantId);
                        console.log(errorThrown);
                    }

                });
              }
              
                return false;
            
            } else if($('#Letter').length) { 

                var productGallery = $('#productImages').val();
                console.log(productGallery);
                console.log($("#id").val());
                prod_properties = { 
                    'Letter': $('#Letter').val(), 
                    '_LetterImage' : $('#productLetterImage').val(),  
                    '_shippinginfo': shippinginfo 
                } 

                return addToCartOT(
                    $("[name='id[]']").map(function(){
                      if($(this).val() != -1) {
                        return $(this).val();
                      }
                    }).get(),
                    $('#Quantity').val(),
                    prod_properties
                );
                

            } else {

                prod_properties = { 
                    '_shippinginfo': shippinginfo 
                }

                //return true;
                return addToCartOT(
                    $("[name='id[]']").map(function(){
                      if($(this).val() != -1) {
                        return $(this).val();
                      }
                    }).get(),
                    $('#Quantity').val(), 
                    prod_properties
                );

            }


                
            return false;


            

        });
      

       
      $('form.productForm select').on('change', function(){
        var productForm = $(this).parents('form.productForm');
        var val = $(this).val();
        productForm.find('[name="id"] option').each(function(){
          var option = $(this).val();
          if (val == $(this).text().trim()) {
            productForm.find('[name="id"]').val(option).trigger('change');
          }
        });
      });
      
      $('form.productForm [name="single_pair"]').on('change', function(){
        var val = $(this).val();
        var qty = $(this).parents('form.productForm').find('#quantity_selector #value').text(val);
      });
      

      $('.productForm').on('submit', function(e){
        e.preventDefault();
        var id = $(this).find('[name="id"]').val();
        var qty = $(this).find('#quantity_selector #value').text();
        return addToCartOT(id, qty);
      });
     
      function addToCartOT(variantId, qty, properties) {
        var productJson = JSON.parse($("[data-product-json]").html());
        var productHandle = productJson.handle;
        if(variantId.constructor === Array && variantId.length == 2) {
          CartJS.addItem(variantId[0], qty, properties, {

              // Define an error callback to display an error message.
              "error": function(jqXHR, textStatus, errorThrown) {
                  console.log(variantId);
                  console.log(errorThrown);
              }

          });

          // add spinner
          $("#addToCart.in-stock-btn").html('<svg style="margin-top:2px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16"><g transform="translate(0, 0)"><g class="nc-loop-circle-3-16-icon-f"><path d="M8 16a8 8 0 1 1 8-8 1 1 0 0 1-2 0 6 6 0 1 0-1.8 4.286 1 1 0 1 1 1.4 1.428A7.956 7.956 0 0 1 8 16z" fill="#ffffff"></path></g><style>.nc-loop-circle-3-16-icon-f{--animation-duration:0.7s;transform-origin:8px 8px;animation:nc-loop-circle-3-anim var(--animation-duration) infinite linear}@keyframes nc-loop-circle-3-anim{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}</style></g></svg>');

          CartJS.addItem(variantId[1], 1, [], {

            // Define a success callback to display a success message.
            "success": function(data, textStatus, jqXHR) {
                $("#addToCart.in-stock-btn").html('Add to Bag');
                if (productHandle == 'gold-band-ring' || productHandle == 'silver-band-ring') {
                  theme.openMinicartOnCartComplete({ delay: 3000, beforeOpen: checkCharacters });
                } else {
                  theme.openMinicartOnCartComplete();
                }

            },

            // Define an error callback to display an error message.
            "error": function(jqXHR, textStatus, errorThrown) {
                console.log(variantId);
                console.log(errorThrown);
                $("#addToCart.in-stock-btn").html('Add to Bag');
            }

        });
        } else {
          $("#addToCart.in-stock-btn").html('<svg style="margin-top:2px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16"><g transform="translate(0, 0)"><g class="nc-loop-circle-3-16-icon-f"><path d="M8 16a8 8 0 1 1 8-8 1 1 0 0 1-2 0 6 6 0 1 0-1.8 4.286 1 1 0 1 1 1.4 1.428A7.956 7.956 0 0 1 8 16z" fill="#ffffff"></path></g><style>.nc-loop-circle-3-16-icon-f{--animation-duration:0.7s;transform-origin:8px 8px;animation:nc-loop-circle-3-anim var(--animation-duration) infinite linear}@keyframes nc-loop-circle-3-anim{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}</style></g></svg>');
          
          CartJS.addItem(variantId, qty, properties, {
              // Define a success callback to display a success message.
              "success": function(data, textStatus, jqXHR) {
                  if (productHandle == 'gold-band-ring' || productHandle == 'silver-band-ring') {
                    theme.openMinicartOnCartComplete({ delay: 3000, beforeOpen: checkCharacters });
                  } else {
                    theme.openMinicartOnCartComplete();
                  }
                  $(document).one('cart.requestComplete.themeAddToCartButton', function() {
                    $("#addToCart.in-stock-btn").html('Add to bag');
                  });
              },

              // Define an error callback to display an error message.
              "error": function(jqXHR, textStatus, errorThrown) {
                  console.log(variantId);
                  console.log(errorThrown);
                  $("#addToCart.in-stock-btn").html('Add to bag');
              }

          });
        }
        return false;
      }
        

    }

});

$(window).load(function() {

    if($('body').hasClass('template-product')) {

        if($("select.engraving").length){

            if($("select.engraving")[0].selectedIndex==1) {
                setTimeout(function(){
                    $('#productEngraving').appendTo($('#formIncludeEngraving'));
                    $('#productEngravingWrapper').fadeIn(300);
                    $('#overlayBG').fadeIn(300);
                    $('html, body').animate({ scrollTop: 0 }, 300);
                },500);
            }

        }


    }

    setTimeout(function(){
        $('body').addClass('loaded');
        var headerRibbon = $('.header_ribbon');

            if(headerRibbon.length>1) {
                setTimeout(function(){
                    fadeHeaderRibbon();
                }, 5000);
            }


            function fadeHeaderRibbon() {
                var current = $('.currentRibbon');
                var currentIndex = headerRibbon.index(current),
                    nextIndex = currentIndex + 1;

                if (nextIndex >= headerRibbon.length) {
                    nextIndex = 0;
                }

                var next = headerRibbon.eq(nextIndex);

                next.stop().fadeIn(300, function() {
                    $(this).addClass('currentRibbon');
                });

                current.stop().fadeOut(300, function() {
                    $(this).removeClass('currentRibbon');
                    setTimeout(fadeHeaderRibbon, 5000);
                });
            }
    },100);


});


$(document).ready(function() {
    if(!$('body').hasClass('template-index')) {
    setTimeout(function(){
        $('body').addClass('loaded');
        $("#loadingWrapper").fadeOut(200, function(){
            
            var headerRibbon = $('.header_ribbon');

            if(headerRibbon.length>1) {
                setTimeout(function(){
                    fadeHeaderRibbon();
                }, 5000);
            }


            function fadeHeaderRibbon() {
                var current = $('.currentRibbon');
                var currentIndex = headerRibbon.index(current),
                    nextIndex = currentIndex + 1;

                if (nextIndex >= headerRibbon.length) {
                    nextIndex = 0;
                }

                var next = headerRibbon.eq(nextIndex);

                next.stop().fadeIn(2000, function() {
                    $(this).addClass('currentRibbon');
                });

                current.stop().fadeOut(2000, function() {
                    $(this).removeClass('currentRibbon');
                    setTimeout(fadeHeaderRibbon, 5000);
                });
            }

        });
    },500);
    }
});   


function preloadImage(productImage){

    
    var zoomRatio = 2;

    var mainImageWidth = 400;
    var mainImageHeight = 560;

    var mainImageSize = (mainImageWidth * 2) + 'x' + (mainImageHeight * 2);
    var mainImageUrl = slate.Image.getSizedImageUrl(productImage, mainImageSize);

    var zoomImageSize = (mainImageWidth * zoomRatio * 2) + 'x' + (mainImageHeight * zoomRatio * 2);
    var zoomImageUrl = slate.Image.getSizedImageUrl(productImage, zoomImageSize);

    // console.log(mainImageUrl);
    // console.log(zoomImageUrl);

    $('<img/>')[0].src = mainImageUrl;
    $('<img/>')[0].src = zoomImageUrl;

}

$(document).ready(function() {
  setTimeout(checkCharacters, 3000);

  $(document).on("click", ".minicart_remove_confirm", function() {
    var minicartItem = $(this).parents(".minicart_item");
    var copy;
    var characterCopy;
    var productProperty;
    var characterProductProperty;
    var postData;
    
    // Configuration: Map of letter product IDs to necklace/bracelet product IDs
    // Note: 7155496091691 is used by both necklace (15431362150774) and bracelet (15496554512758)
    var LETTER_TO_PRODUCT_MAP = {
      '7155496091691': ['15431362150774', '15496554512758'],  // Diamond Initial Pendant -> Personalised Initial Diamond Necklace or Bracelet
      '7155492782123': ['15433051996534']   // New letter product -> Personalised Tiny Diamond Tag Necklace
    };
    
    // Get the item index from the button's data attribute (Rivets uses index + 1)
    var $removeButton = $(this);
    var $minicartItems = $('#minicart_items .minicart_item');
    var itemPosition = $minicartItems.index(minicartItem);
    
    // Try to get product ID from the minicart item's data or from CartJS
    var productId = null;
    
    // Method 1: Try to get from CartJS cart items
    if (typeof CartJS !== 'undefined' && CartJS.cart && CartJS.cart.items && CartJS.cart.items[itemPosition] !== undefined) {
      var cartItem = CartJS.cart.items[itemPosition];
      productId = String(cartItem.product_id);
      console.log('Got product ID from CartJS:', productId, 'at position:', itemPosition);
    }
    
    // Method 2: Try to get from the minicart item's data attributes (if Rivets exposes it)
    if (!productId) {
      var $productTitle = minicartItem.find('.minicart_product_title');
      var productTitle = $productTitle.text().trim();
      console.log('Product title:', productTitle);
      
      // Check if this is a known letter product by title (fallback method)
      // This is not ideal - prefer getting ID from CartJS above
      if (productTitle.indexOf('Diamond Initial Pendant') !== -1 || 
          productTitle.indexOf('Initial Pendant') !== -1) {
        // Try to match by checking all letter product IDs
        // We can't determine which one without the ID, so skip this method
        // The CartJS method above should work
      }
    }
    
    // Get cart item to check product ID
    // Only proceed if we have a valid productId AND it's a letter product
    if (productId) {
      
      // Check if removing a letter product - find corresponding necklace/bracelet product IDs
      var correspondingProductIds = LETTER_TO_PRODUCT_MAP[String(productId)];
      
      if (correspondingProductIds && correspondingProductIds.length > 0) {
        console.log('Letter product detected for removal, will remove corresponding necklace/bracelet after. Letter ID:', productId, 'Product IDs:', correspondingProductIds);
        
        // Flag to prevent duplicate removal attempts
        // Reset flag if it's been set for more than 5 seconds (in case of previous failure)
        var removalKey = 'removing_products_' + productId;
        if (window[removalKey]) {
          var timeSinceStart = Date.now() - (window[removalKey + '_start'] || 0);
          if (timeSinceStart > 5000) {
            console.log('Previous removal attempt timed out, resetting flag');
            window[removalKey] = false;
          } else {
            console.log('Product removal already in progress, skipping...');
            // Don't return here - let the normal removal flow continue
            // The flag will prevent duplicate product removal attempts
          }
        }
        
        // Only set up removal handler if not already in progress
        if (!window[removalKey]) {
          window[removalKey] = true;
          window[removalKey + '_start'] = Date.now();
          
          // Function to remove necklace/bracelet products
          var removeProducts = function() {
            console.log('removeProducts called, getting cart...');
            
            // Use CartJS.cart directly first (synchronous), then refresh if needed
            var cart = CartJS.cart;
            if (!cart || !cart.items || cart.items.length === 0) {
              console.log('CartJS.cart not available, fetching fresh cart...');
              CartJS.getCart(function(freshCart) {
                if (!freshCart || !freshCart.items) {
                  console.log('No cart or items found after fetch');
                  window[removalKey] = false;
                  window[removalKey + '_start'] = null;
                  return;
                }
                processProductRemoval(freshCart, correspondingProductIds, removalKey);
              });
              return;
            }
            
            processProductRemoval(cart, correspondingProductIds, removalKey);
          };
          
          // Helper function to process product removal (handles multiple products)
          var processProductRemoval = function(cart, productIds, removalKey) {
            console.log('Processing product removal, cart has', cart.items.length, 'items. Looking for product IDs:', productIds);
            
            // Find and remove all matching products (necklace/bracelet)
            var productIndices = [];
            cart.items.forEach(function(item, index) {
              console.log('Checking item at index', index, 'product_id:', item.product_id, 'type:', typeof item.product_id);
              // Check if this item's product_id matches any of the product IDs we're looking for
              var matches = productIds.some(function(pid) {
                return String(item.product_id) === String(pid);
              });
              if (matches) {
                productIndices.push(index);
                console.log('Found matching product at index:', index);
              }
            });
          
          // Remove products in reverse order to avoid index shifting
          if (productIndices.length > 0) {
            console.log('Removing', productIndices.length, 'product(s)');
            var removeNext = function() {
              if (productIndices.length === 0) {
                console.log('All products removed');
                return;
              }
              
              var index = productIndices.pop();
              console.log('Removing product at index:', index);
              
              // Use the cart we already have, or get fresh one
              var currentCart = cart || CartJS.cart;
              
              // Find current product indices
              var currentProductIndices = [];
              if (currentCart && currentCart.items) {
                currentCart.items.forEach(function(item, idx) {
                  var matches = productIds.some(function(pid) {
                    return String(item.product_id) === String(pid);
                  });
                  if (matches) {
                    currentProductIndices.push(idx);
                    console.log('Found matching product at index:', idx);
                  }
                });
              }
              
              if (currentProductIndices.length === 0) {
                console.log('No matching products found in current cart, fetching fresh cart...');
                // Try to get fresh cart
                CartJS.getCart(function(freshCart) {
                  if (!freshCart || !freshCart.items) {
                    console.log('No cart items found');
                    window[removalKey] = false;
                    window[removalKey + '_start'] = null;
                    return;
                  }
                  
                  var freshProductIndices = [];
                  freshCart.items.forEach(function(item, idx) {
                    var matches = productIds.some(function(pid) {
                      return String(item.product_id) === String(pid);
                    });
                    if (matches) {
                      freshProductIndices.push(idx);
                    }
                  });
                  
                  if (freshProductIndices.length === 0) {
                    console.log('No matching products found in fresh cart');
                    window[removalKey] = false;
                    window[removalKey + '_start'] = null;
                    return;
                  }
                  
                  removeProductByIndex(freshProductIndices[0], productIds, removalKey);
                });
                return;
              }
              
              // Use the first product index
              var currentIndex = currentProductIndices[0];
              removeProductByIndex(currentIndex, productIds, removalKey);
            };
            
            // Helper function to remove product by index
            var removeProductByIndex = function(currentIndex, productIds, removalKey) {
              console.log('Removing product at index:', currentIndex, 'Product IDs:', productIds);
              
              // Remove using the line number (1-based for Shopify API)
              var lineNumber = currentIndex + 1;
              console.log('Using line number:', lineNumber, 'for cart/change.js');
              
              // Use Shopify's cart/change.js API directly (more reliable)
              console.log('Making AJAX call to /cart/change.js with line:', lineNumber);
              $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: {
                  line: lineNumber,
                  quantity: 0
                },
                dataType: 'json',
                timeout: 10000,
                success: function(cart) {
                  console.log('AJAX success! Removed necklace product using cart/change.js', cart);
                  window[removalKey] = false;
                  window[removalKey + '_start'] = null;
                  // Refresh CartJS cart
                  CartJS.getCart(function(updatedCart) {
                    console.log('Cart refreshed after removal, items:', updatedCart ? updatedCart.items.length : 0);
                    // Check if there are more necklaces to remove
                    var remainingNecklaces = [];
                    if (updatedCart && updatedCart.items) {
                      updatedCart.items.forEach(function(item, idx) {
                        if (String(item.product_id) === String(necklaceProductId)) {
                          remainingNecklaces.push(idx);
                        }
                      });
                    }
                    if (remainingNecklaces.length > 0) {
                      console.log('More necklaces found, removing...');
                      necklaceIndices = remainingNecklaces.reverse();
                      window[removalKey] = true;
                      window[removalKey + '_start'] = Date.now();
                      setTimeout(removeNext, 500);
                    } else {
                      console.log('All necklace products removed successfully');
                    }
                  });
                },
                error: function(jqXHR, textStatus, errorThrown) {
                  console.error('AJAX error removing necklace product:', errorThrown, textStatus);
                  console.error('Status code:', jqXHR.status);
                  console.error('Response text:', jqXHR.responseText);
                  window[removalKey] = false;
                  window[removalKey + '_start'] = null;
                  // Fallback: try CartJS.removeItem
                  console.log('Trying CartJS.removeItem as fallback...');
                  CartJS.removeItem(currentIndex, {
                    success: function(data) {
                      console.log('Successfully removed necklace product via CartJS', data);
                      window[removalKey] = false;
                      window[removalKey + '_start'] = null;
                      CartJS.getCart();
                    },
                    error: function(err) {
                      console.error('CartJS.removeItem also failed:', err);
                      window[removalKey] = false;
                      window[removalKey + '_start'] = null;
                    }
                  });
                },
                complete: function() {
                  console.log('AJAX request completed (success or error)');
                }
              });
            };
            
            removeNext();
          } else {
            console.log('No necklace products found to remove. Cart items:', cart.items.map(function(i) { return i.product_id + ' (' + i.product_title + ')'; }));
          }
          };
          
          // Wait for the letter to be removed first, then remove necklace
          // Use multiple methods to ensure we catch the cart update
          var removalHandlerFired = false;
          var removalHandler = function(event, cart) {
            if (removalHandlerFired) {
              console.log('Removal handler already fired, skipping...');
              return;
            }
            removalHandlerFired = true;
            console.log('Cart update detected, checking for necklace removal');
            // Use a small delay to ensure the letter removal is complete
            setTimeout(removeNecklaceProducts, 500);
          };
          
          // Listen for cart.requestComplete event (only once)
          // Use a namespace to avoid conflicts with other handlers
          var eventNamespace = '.necklaceRemoval_' + Date.now();
          $(document).one('cart.requestComplete' + eventNamespace, removalHandler);
          
          // Also set a fallback timeout in case the event doesn't fire
          setTimeout(function() {
            if (!removalHandlerFired) {
              $(document).off('cart.requestComplete' + eventNamespace, removalHandler);
              removalHandlerFired = true;
              removeNecklaceProducts();
            }
          }, 2000);
          
          // Trigger the namespaced event when cart.requestComplete fires
          // This ensures our handler doesn't interfere with other handlers
          $(document).one('cart.requestComplete', function(event, cart) {
            $(document).trigger('cart.requestComplete' + eventNamespace, [cart]);
          });
        }
      }
    }
    
    minicartItem.find(".minicart_item_properties li").each(function() {
      var property = $(this).find("span span small").html().trim();
      if (property.indexOf("Copy") !== -1) {
        copy = property;
      } else if (property.indexOf("Product") !== -1) {
        productProperty = property;
      }
    });

    $("#minicart_items .minicart_item").each(function(index) {
      var title = $(this).find(".minicart_product_title").html().trim();
      if (title == 'Additional characters') {
        var characterHtml = $(this).find(".minicart_item_properties").html();
        if(characterHtml.indexOf(copy) !== -1 && characterHtml.indexOf(productProperty) !== -1) {
          postData = {
            line: index,
            quantity: 0
          };
          setTimeout(() => {
            CartJS.removeItem(index);
          }, 1000);
        }
      }
    });
  });
  
  // Ensure letters are only in cart if necklace is present
  // Store letter item keys instead of indices to avoid index shifting issues
  var NECKLACE_PRODUCT_ID = '15431362150774';
  var LETTER_PRODUCT_ID = '7155496091691';
  var isCleaningLetters = false;
  var cleanupCheckRunning = false;
  
  // Function to find current index of an item by its key
  var findItemIndexByKey = function(cart, itemKey) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].key === itemKey) {
        return i;
      }
    }
    return -1;
  };
  
  // Function to clean up orphaned letters
  var cleanupOrphanedLetters = function() {
    if (isCleaningLetters || cleanupCheckRunning) {
      return;
    }
    
    cleanupCheckRunning = true;
    
    CartJS.getCart(function(cart) {
      cleanupCheckRunning = false;
      
      if (!cart || !cart.items || cart.items.length === 0) {
        return;
      }
      
      // Check if necklace exists
      var hasNecklace = false;
      cart.items.forEach(function(item) {
        if (String(item.product_id) === NECKLACE_PRODUCT_ID) {
          hasNecklace = true;
        }
      });
      
      // If necklace exists, do nothing
      if (hasNecklace) {
        return;
      }
      
      // Find letters that need to be removed - store by key, not index
      var letterKeysToRemove = [];
      cart.items.forEach(function(item) {
        var itemId = String(item.product_id);
        
        // Only process letter products
        if (itemId === LETTER_PRODUCT_ID && item.key) {
          // Since there's only one necklace product that uses letters,
          // we can remove all letter products if the necklace isn't present
          letterKeysToRemove.push(item.key);
        }
      });
      
      // Remove letters if found
      if (letterKeysToRemove.length > 0) {
        isCleaningLetters = true;
        
        var removeNext = function() {
          if (letterKeysToRemove.length === 0) {
            isCleaningLetters = false;
            return;
          }
          
          var itemKey = letterKeysToRemove.shift();
          
          // Get fresh cart and find current index
          CartJS.getCart(function(freshCart) {
            if (!freshCart || !freshCart.items) {
              isCleaningLetters = false;
              return;
            }
            
            var currentIndex = findItemIndexByKey(freshCart, itemKey);
            
            if (currentIndex === -1) {
              // Item already removed, continue
              setTimeout(removeNext, 300);
              return;
            }
            
            // Verify it's still a letter product
            var item = freshCart.items[currentIndex];
            if (!item || String(item.product_id) !== LETTER_PRODUCT_ID) {
              // Item changed, skip
              setTimeout(removeNext, 300);
              return;
            }
            
            // Remove by current index
            CartJS.removeItem(currentIndex, {
              success: function() {
                setTimeout(removeNext, 800);
              },
              error: function() {
                setTimeout(removeNext, 800);
              }
            });
          });
        };
        
        removeNext();
      }
    });
  };
  
  // Run cleanup after cart updates, but with delay and debouncing
  var cleanupTimeout = null;
  $(document).on('cart.requestComplete', function(event, cart) {
    // Clear any pending cleanup
    if (cleanupTimeout) {
      clearTimeout(cleanupTimeout);
    }
    
    // Wait a bit before checking (let cart settle)
    cleanupTimeout = setTimeout(function() {
      cleanupOrphanedLetters();
    }, 1500);
  });
});
checkCharacters = () => {
  $("#minicart_items .minicart_item").each(function() {
    var title = $(this).find(".minicart_product_title").html().trim();
    if (title == 'Additional characters') {
      $(this).find(".minicart_quantity_disabled").addClass("character-hidden");
      $(this).find(".minicart_quantity > a").addClass("character-hidden");
      $(this).find(".minicart_remove_toggle").addClass("character-hidden");
    } else {
      $(this).find(".minicart_quantity_disabled").removeClass("character-hidden");
      $(this).find(".minicart_quantity > a").removeClass("character-hidden");
      $(this).find(".minicart_remove_toggle").removeClass("character-hidden");
    }
  });
};

(function($) {
  // Use event delegation so it works for multiple buttons and dynamic content
  $(document).on('click', '.crosssell-add', function () {
    var $btn = $(this);
    var currentHtml = $btn.html();

    // Spinner
    $btn.html(
      '<svg style="margin-top:2px" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">' +
        '<g><g class="nc-loop-circle-3-16-icon-f">' +
          '<path d="M8 16a8 8 0 1 1 8-8 1 1 0 0 1-2 0 6 6 0 1 0-1.8 4.286 1 1 0 1 1 1.4 1.428A7.956 7.956 0 0 1 8 16z" fill="#000"></path>' +
        '</g>' +
        '<style>.nc-loop-circle-3-16-icon-f{--animation-duration:.7s;transform-origin:8px 8px;animation:nc-loop-circle-3-anim var(--animation-duration) infinite linear}@keyframes nc-loop-circle-3-anim{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}</style>' +
      '</g></svg>'
    );

    // Get the variant ID relative to the clicked item
    var variantId = $btn.closest('.minicart_item').find('.crosssell_product_id').val();

    CartJS.addItem(variantId, 1, [], {
      success: function () {
        // Handle the next cart completion only once
        theme.openMinicartOnCartComplete();
        $(document).one('cart.requestComplete.themeCrosssellButton', function () {
          $btn.html(currentHtml);
        });
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log('Cross-sell add error for variant', variantId, errorThrown);
        $btn.html(currentHtml);
      }
    });
  });
})(jQuery);

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});

$(document).ready(function(){
  $('.share').click(function(event) {
    $(this).toggleClass("is-active");
  });

    $('.product').click(function() {
      $(this).each(function() {
        var close = $(this).find('.close');

        $(close).on('click',function(){
          $(this).closest('.product').removeClass("is-active");
          event.stopPropagation();
        });
        
        if ( $( this ).hasClass( "is-active" ) ) {
          
        } else {
          $(this).closest('.product').removeClass("is-active");
          $(this).addClass("is-active");
        }
      });
    });
});

$(document).ready(function(){
  $('.reading-grid').slick({
    infinite: false,
    slidesToShow: 3,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 900,
        settings: {
         slidesToShow: 2.2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.1,
        }
      }
    ]
  });
});

$(document).ready(function(){
  $('.personaliseSliderMobile').slick({
    centerMode: true,
    infinite: true,
    slidesToShow: 3,
    arrows: false,
    dots: false,
    initialSlide: 1,
    responsive: [
      {
        breakpoint: 900,
        settings: {
         slidesToShow: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
});

$(document).ready(function(){
  $('.homepage-product-grid').slick({
    centerMode: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: false,
    dots: false,
    initialSlide: 0,
    responsive: [
      {
        centerMode: true,
        breakpoint: 900,
        initialSlide: 2,
        slidesToScroll: 2,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        centerMode: true,
        breakpoint: 600,
        initialSlide: 1,
        slidesToScroll: 1,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});

$(document).ready(function(){
  $('.personalistation-product-grid').slick({
    centerMode: false,
    infinite: false,
    arrows: true,
    slidesToScroll: 1,
    rows: 1,
    swipeToSlide: true,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 900,
        initialSlide: 2,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        initialSlide: 2,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
});

$('#earring_single_pair input#1').click(function(){
    $('.product-price .pair-price').hide();
    $('.product-price .single-price').show();
  
  	$('.pair-free-shipping').hide();
});

$('#earring_single_pair input#2').click(function(){
    $('.product-price .single-price').hide();
    $('.product-price .pair-price').show();
  	if ($(".single-free-shipping")[0]){
      $('.pair-free-shipping').hide();
    } else {
      $('.pair-free-shipping').show();
    }
});


// Gallery for engraving type
if (document.getElementById("font-style-modal-Block-hand-engraving")) {
  var fontStyleModalBlock = function() {
    var pswpElement = document.querySelectorAll('.pswp')[0];

    var items = [
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/disc-block-1.png',
        w: 1200,
        h: 1200
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/disc-block-2.png',
        w: 1200,
        h: 1200
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/disc-block-3.png',
        w: 1200,
        h: 1200
      }
    ];

    var options = {};
    var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
  };
  document.getElementById('font-style-modal-Block-hand-engraving').onclick = fontStyleModalBlock;
}



// Gallery for engraving type
if (document.getElementById("font-style-modal-Block-machine-engraving")) {
  var fontStyleModalBlockMachine = function() {
    var pswpElement = document.querySelectorAll('.pswp')[0];

    var items = [
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/disc-block-1.png',
        w: 1200,
        h: 1200
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/disc-block-2.png',
        w: 1200,
        h: 1200
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/disc-block-3.png',
        w: 1200,
        h: 1200
      }
    ];

    var options = {};
    var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
  };
  document.getElementById('font-style-modal-Block-machine-engraving').onclick = fontStyleModalBlockMachine;
}




// Gallery for engraving type
if (document.getElementById("font-style-modal-Block-vermeil-complimentary-engraving")) {
  var fontStyleModalBlockVermeil = function() {
    var pswpElement = document.querySelectorAll('.pswp')[0];

    var items = [
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/disc-block-1.png',
        w: 1200,
        h: 1200
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/disc-block-2.png',
        w: 1200,
        h: 1200
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/disc-block-3.png',
        w: 1200,
        h: 1200
      }
    ];

    var options = {};
    var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
  };
  document.getElementById('font-style-modal-Block-vermeil-complimentary-engraving').onclick = fontStyleModalBlockVermeil;
}










if (document.getElementById("font-style-modal-Script-hand-engraving")) {
  var fontStyleModalScript = function() {
    var pswpElement = document.querySelectorAll('.pswp')[0];

    var items = [
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/disc-script-1.png',
        w: 1200,
        h: 1200
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/disc-script-2.png',
        w: 1200,
        h: 1200
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/disc-script-3.png',
        w: 1200,
        h: 1200
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/disc-script-4.png',
        w: 1200,
        h: 1200
      }
    ];

    var options = {};
    var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
  };
  document.getElementById('font-style-modal-Script-hand-engraving').onclick = fontStyleModalScript;
}




if (document.getElementById("font-style-modal-Script-machine-engraving")) {
  var fontStyleModalScriptMachine = function() {
    var pswpElement = document.querySelectorAll('.pswp')[0];

    var items = [
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/disc-script-1.png',
        w: 1200,
        h: 1200
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/disc-script-2.png',
        w: 1200,
        h: 1200
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/disc-script-3.png',
        w: 1200,
        h: 1200
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/disc-script-4.png',
        w: 1200,
        h: 1200
      }
    ];

    var options = {};
    var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
  };
  document.getElementById('font-style-modal-Script-machine-engraving').onclick = fontStyleModalScriptMachine;
}






if (document.getElementById("font-style-modal-Script-vermeil-complimentary-engraving")) {
  var fontStyleModalScriptVermeil = function() {
    var pswpElement = document.querySelectorAll('.pswp')[0];

    var items = [
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/disc-script-1.png',
        w: 1200,
        h: 1200
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/disc-script-2.png',
        w: 1200,
        h: 1200
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/disc-script-3.png',
        w: 1200,
        h: 1200
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/disc-script-4.png',
        w: 1200,
        h: 1200
      }
    ];

    var options = {};
    var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
  };
  document.getElementById('font-style-modal-Script-vermeil-complimentary-engraving').onclick = fontStyleModalScriptVermeil;
}





// Gallery for engraving type
if (document.getElementById("ring-font-style-modal-Block-hand-engraving")) {
  var ringFontStyleModalBlock = function() {
    var pswpElement = document.querySelectorAll('.pswp')[0];

    var items = [
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/ring-block-1.png',
        w: 1200,
        h: 1200
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/ring-block-2.png',
        w: 1200,
        h: 1200
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/ring-block-3.png',
        w: 1200,
        h: 1200
      }
    ];

    var options = {};
    var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
  };
  document.getElementById('ring-font-style-modal-Block-hand-engraving').onclick = ringFontStyleModalBlock;
}


// Gallery for engraving type
if (document.getElementById("ring-font-style-modal-Script-hand-engraving")) {
  var ringFontStyleModalScript = function() {
    var pswpElement = document.querySelectorAll('.pswp')[0];

    var items = [
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/ring-script-1.png',
        w: 1200,
        h: 1200
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/ring-script-2.png',
        w: 1200,
        h: 1200
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/ring-script-3.png',
        w: 1200,
        h: 1200
      }
    ];

    var options = {};
    var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
  };
  document.getElementById('ring-font-style-modal-Script-hand-engraving').onclick = ringFontStyleModalScript;
}


// Hidden ring 
if (document.getElementById("ring-font-style-modal-Block-hidden-ring-complimentary-engraving")) {
  var fontStyleModalBlockHiddenRing = function() {
    var pswpElement = document.querySelectorAll('.pswp')[0];

    var items = [
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/ring-block-1.png',
        w: 1200,
        h: 1200
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/ring-block-2.png',
        w: 1200,
        h: 1200
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/ring-block-3.png',
        w: 1200,
        h: 1200
      }
    ];

    var options = {};
    var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
  };
  document.getElementById('ring-font-style-modal-Block-hidden-ring-complimentary-engraving').onclick = fontStyleModalBlockHiddenRing;
}

if (document.getElementById("ring-font-style-modal-Script-hidden-ring-complimentary-engraving")) {
  var ringFontStyleModalScript = function() {
    var pswpElement = document.querySelectorAll('.pswp')[0];

    var items = [
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/hidden-ring-script-1.png',
        w: 1200,
        h: 1200
      }
    ];

    var options = {};
    var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
  };
  document.getElementById('ring-font-style-modal-Script-hidden-ring-complimentary-engraving').onclick = ringFontStyleModalScript;
}



// solid gold ring
if (document.getElementById("solid-gold-ring-font-style-modal-Block-hand-engraving")) {
  var ringFontStyleModalBlockSolidGold = function() {
    var pswpElement = document.querySelectorAll('.pswp')[0];

    var items = [
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/DSC7266_1428x2000_crop_center.progressive.jpg',
        w: 1200,
        h: 2000
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/DSC7267_1428x2000_crop_center.progressive.jpg',
        w: 1428,
        h: 2000
      }
    ];

    var options = {};
    var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
  };
  document.getElementById('solid-gold-ring-font-style-modal-Block-hand-engraving').onclick = ringFontStyleModalBlockSolidGold;
}

if (document.getElementById("solid-gold-ring-font-style-modal-Script-hand-engraving")) {
  var ringFontStyleModalScriptSolidGold = function() {
    var pswpElement = document.querySelectorAll('.pswp')[0];

    var items = [
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/DSC7264_1428x2000_crop_center.progressive.jpg',
        w: 1428,
        h: 2000
      }
      // {
      //   src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/ring-script-2.png',
      //   w: 1200,
      //   h: 1200
      // },
      // {
      //   src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/ring-script-3.png',
      //   w: 1200,
      //   h: 1200
      // }
    ];

    var options = {};
    var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
  };
  document.getElementById('solid-gold-ring-font-style-modal-Script-hand-engraving').onclick = ringFontStyleModalScriptSolidGold;
}

// Silver band ring
if (document.getElementById("ring-font-style-modal-Block-machine-engraving")) {
  var ringFontStyleModalBlockMachine = function() {
    var pswpElement = document.querySelectorAll('.pswp')[0];

    var items = [
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/DSC7266_1428x2000_crop_center.progressive.jpg',
        w: 1200,
        h: 2000
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/DSC7267_1428x2000_crop_center.progressive.jpg',
        w: 1428,
        h: 2000
      }
    ];

    var options = {};
    var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
  };
  document.getElementById('ring-font-style-modal-Block-machine-engraving').onclick = ringFontStyleModalBlockMachine;
}

if (document.getElementById("ring-font-style-modal-Script-machine-engraving")) {
  var ringFontStyleModalScriptMachine = function() {
    var pswpElement = document.querySelectorAll('.pswp')[0];

    var items = [
      {
        src: 'https://cdn.shopify.com/s/files/1/2602/7280/files/DSC7264_1428x2000_crop_center.progressive.jpg',
        w: 1428,
        h: 2000
      }
    ];

    var options = {};
    var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
  };
  document.getElementById('ring-font-style-modal-Script-machine-engraving').onclick = ringFontStyleModalScriptMachine;
}

$(document).ready(function(){
  $('.gallery-hunza').slick({
    infinite: true,
    slidesToShow: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: false
  });
});


$(document).ready(function(){
   $(".site-nav__submenu a:contains('NEW: ')").each(function() {
    var replaced = $(this).html().replace('NEW: ', " ");
    $(this).html(replaced);
    $(this).parent().append("<span class='new-flag'>new</span>");
  });
});


// CAMILLA
$(document).ready(function(){
  $('.intro-dual-slider-one div').slick({
    infinite: true,
    slidesToShow: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: false
  });

  $('.intro-dual-slider-two div').slick({
    infinite: true,
    slidesToShow: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: false
  });
});

